import { render, staticRenderFns } from "./SpecProfile.vue?vue&type=template&id=80e886b6&scoped=true"
import script from "./SpecProfile.vue?vue&type=script&lang=js"
export * from "./SpecProfile.vue?vue&type=script&lang=js"
import style0 from "./SpecProfile.vue?vue&type=style&index=0&id=80e886b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e886b6",
  null
  
)

export default component.exports